import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { derivedGoalNote } from "./rphGoal";
import "./customize.css";

/**
 * The goal on a Technicians' Revenue per Hour card, in $/hr.
 *
 * That metric is computed (company revenue over Technicians' hours), so it has no
 * target to edit: left alone it borrows whatever goal the company's own anchor
 * metric carries, and an admin cannot see or change it from here. This box sets
 * the card's own goal; clearing it goes back to the borrowed one. Shown only
 * when the card actually has the metric — see `hasRphMetric`.
 *
 * The box keeps its own text so clearing "175" to type "200" does not read as
 * "goal removed" halfway through; a valid number is committed as it is typed.
 */
const RphGoalField = ({ value, onChange }) => {
  const [text, setText] = useState(value ? String(value) : "");
  useEffect(() => { setText(value ? String(value) : ""); }, [value]);
  return (
    <div className="gmbw-fld">
      <label htmlFor="gmbw-rph-goal">Revenue per Hour goal</label>
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <span className="gmbw-pc-dollar">$</span>
        <input
          id="gmbw-rph-goal"
          className="gmbw-input"
          style={{ width: 96, flex: "none" }}
          type="number"
          min="1"
          step="any"
          inputMode="decimal"
          placeholder="175"
          value={text}
          onChange={(e) => {
            const raw = e.target.value;
            setText(raw);
            const n = Number(raw);
            if (raw === "") onChange(null);
            else if (Number.isFinite(n) && n > 0) onChange(n);
          }}
          onBlur={() => setText(value ? String(value) : "")}
        />
        <span className="gmbw-pc-dollar">/hr</span>
      </div>
      <p className="gmbw-hint" style={{ marginTop: 6 }}>{derivedGoalNote(value)}</p>
    </div>
  );
};

RphGoalField.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};
RphGoalField.defaultProps = { value: null };

export default RphGoalField;
